import React, {useEffect, useRef, useState} from 'react';
import cl from '../../styles/StudAddPage.module.css'
import {useNavigate} from "react-router-dom";
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";
import clip from '../../Assets/icons/clip.svg'
import UploadModal from "../../components/UI/UploadModal/UploadModal";
import Service from "../../API/Service";
import arrow from "../../Assets/icons/Vector.svg";
import edit from '../../styles/StudEditPage.module.css'

const StudAddPage = () => {
    const navigate = useNavigate();
    const entity = "students"
    const dropdownRef = useRef(null);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [modal, setModal] = useState(false);
    const [updatedData, setUpdatedData] = useState({
        name: "",
        surname: "",
        birthDate: "",
        departmentId: null,
        login: "",
        phone: "",
    });

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await Service.getTables("departments");
                setDepartments(response?.data?.content || []);
            } catch (error) {
                console.error("Ошибка загрузки департаментов:", error);
            }
        };

        fetchDepartments();
    }, []);

    const columns = ["Name", "Surname", "Date of birth", "Department", "Email", "Phone number"]

    const handleChange = (field, value) => {
        setUpdatedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const createStudent = async () => {
        try {
            const studentData = {
                user: {
                    login: updatedData.login,
                    name: updatedData.name,
                    surname: updatedData.surname,
                    birthDate: updatedData.birthDate,
                    phone: updatedData.phone
                },
                departmentId: updatedData.departmentId
            };

            await Service.createDep(studentData, entity);
            alert("Студент успешно создан!");
            navigate(-1);
        } catch (error) {
            alert("Ошибка при создании студента!");
        }
    };

    const handleDepartmentSelect = (id) => {
        handleChange("departmentId", id);
        setDropdownOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={cl.wrap}>
            <UploadModal
                visible={modal}
                setVisible={setModal}
                list={columns}
                entity={entity}
            />
            <p>Students</p>
            <div className={cl.content}>
                <MyInput
                    onChange={(value) => handleChange("name", value)}
                    info={{ name: "Name", value: updatedData.name }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("surname", value)}
                    info={{ name: "Surname", value: updatedData.surname }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("birthDate", value)}
                    info={{ name: "Date of Birth", value: updatedData.birthDate }}
                    isDisabled={false}
                />
                <div className={edit.dropdown} ref={dropdownRef}>
                    Department
                    <div className={edit.dropdownButton} onClick={() => setDropdownOpen(!dropdownOpen)}>
                        {departments.find(dep => dep.id === updatedData.departmentId)?.name || "Select department"}
                        <img src={arrow} alt={"arrow"} className={dropdownOpen? edit.arrowDown : edit.arrowUp}/>
                    </div>
                    {dropdownOpen && (
                        <ul className={edit.dropdownMenu}>
                            {departments
                                .filter(dep => dep.id !== updatedData.departmentId)
                                .map(dep => (
                                    <li
                                        key={dep.id}
                                        onClick={() => handleDepartmentSelect(dep.id)}
                                        className={edit.dropdownItem}
                                    >
                                        {dep.name}
                                    </li>
                                ))}
                        </ul>
                    )}
                </div>
                <MyInput
                    onChange={(value) => handleChange("login", value)}
                    info={{ name: "Email", value: updatedData.login }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("phone", value)}
                    info={{ name: "Phone Number", value: updatedData.phone }}
                    isDisabled={false}
                />
            </div>
            <div className={cl.btns}>
                <MyButton
                    content={"Back"}
                    isBlue={false}
                    onClick={() => navigate(-1)}
                />
                <MyButton
                    content={"Create new student"}
                    isBlue={true}
                    onClick={createStudent}
                />
            </div>
            <button className={cl.upload} onClick={() => setModal(true)}>
                <img src={clip} alt={"clip"}/>
                Upload list
            </button>
        </div>
    );
};

export default StudAddPage;